import { TextEncoder } from "text-encoding";

/* global window */
if (typeof window.TextEncoder === "undefined") {
  window.TextEncoder = TextEncoder;
}
